import { Box, ButtonBase, Checkbox, Divider, Grid, LinearProgress, Stack } from "@mui/material";
import CustomTextField from "../../../components/Form/CustomTextField";
import React, { useEffect } from "react";
import CustomButton from "../../../components/Form/CustomButton";
import AppDialog from "../../../components/Common/AppDialog";
import Label from "../../../components/Common/Label";
import { Icon } from "@iconify/react/dist/iconify.js";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton";
import VehicleDetailsSummaryModal from "../modal/VehicleDetailsSummary";
import { connect } from "react-redux";
import Helpers from "../../../helpers/helpers";
import moment from "moment";

const AddContact = ({ formObj, handleFormChange, vehicle, windowWidth, bodyList, username, userEmail, isSingPass, userPhone, isDirectSeller, userData }) => {

    const [newContact, setNewContact] = React.useState({});
    const [selectedRow, setSelectedRow] = React.useState();
    const [selectedIndex, setSelectedIndex] = React.useState();
    const [openDialog, setOpenDialog] = React.useState(false);
    const [defaultOpen, setDefaultOpen] = React.useState(false);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [detailOpen, setDetailOpen] = React.useState(false);

    useEffect(() => {
        if (isDirectSeller && userData?.profile) {
            handleFormChange('contacts', [{ name: userData?.profile?.name || '', phone: userData?.profile?.phone }]);
        }
    }, [userData, isDirectSeller])

    const handleNewContactChange = (key, value) => {
        let tempContacts = { ...newContact };
        tempContacts[key] = value;
        setNewContact(tempContacts);
    }

    const handleEditContactChange = (key, value) => {
        let tempContacts = { ...selectedRow };
        tempContacts[key] = value;
        setSelectedRow(tempContacts);
    }

    const handleSaveChanges = () => {
        let tempContacts = [...formObj.contacts || []];
        if (selectedRow && (selectedIndex || selectedIndex === 0)) {
            tempContacts[selectedIndex] = selectedRow;
            handleFormChange('contacts', tempContacts);
            setSelectedRow(null);
            setSelectedIndex(null);

        } else {
            tempContacts.push(newContact);
            handleFormChange('contacts', tempContacts);
            setNewContact({});
        }
        setOpenDialog(false);
    }

    const handleDeleteContact = () => {
        let tempContacts = [...formObj.contacts || []];
        if (selectedIndex || selectedIndex === 0) {
            tempContacts.splice(selectedIndex, 1);
            handleFormChange('contacts', tempContacts);
            setSelectedIndex(null);
        }
        setDeleteOpen(false);
    }

    const handleSetAsDefault = () => {
        let tempContacts = [...formObj.contacts || []];
        tempContacts = tempContacts.map((contact, index) => {
            if (index === selectedIndex) {
                return { ...contact, is_default: true }
            } else {
                return { ...contact, is_default: false }
            }
        })
        handleFormChange('contacts', tempContacts);
        setSelectedRow(null);
        setSelectedIndex(null);
        setDefaultOpen(false);
    }
    return (
        <React.Fragment>
            <Box className="vehicle-info-container">
                <div className="vehicle-selected-absolute">
                    Selected
                </div>
                <div className="text-semibold font-size-18">{vehicle?.make || '-'} {vehicle?.model || ''} {vehicle?.manu_year ? (`(${vehicle?.manu_year})`) : ''}</div>
                <Box sx={{ display: { lg: 'flex', md: 'flex' }, justifyContent: { lg: 'space-between', md: 'space-between' } }}>
                    <Stack sx={{ flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' }, gap: 2, mt: 2 }}>
                        <div className="d-flex align-items-center">
                            <div className="subheader-2">Reg. No:</div>
                            <div className="mx-1">{vehicle?.reg_no || '-'}</div>
                        </div>
                        {!isSingPass ?
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">Stock ID:</div>
                                    <div className="mx-1">{formObj?.stock_id || '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">Body Type:</div>
                                    <div className="mx-1">{Array.isArray(vehicle?.body_type) && vehicle?.body_type.length > 0 ? vehicle.body_type?.map((item, idx) => bodyList?.find((body) => body.id === item)?.name).join(', ') : vehicle?.body_type || '-'}</div>
                                </div>
                            </> :
                            <>
                                <div className="d-flex align-items-center">
                                    <div className="subheader-2">COE Expiry Date:</div>
                                    <div className="mx-1">{vehicle?.coe_expiry ? moment(vehicle?.coe_expiry, "YYYY-MM-DD").format('DD-MM-YYYY') : '-'}</div>
                                </div> <div className="d-flex align-items-center">
                                    <div className="subheader-2">No. of Owner(s):</div>
                                    <div className="mx-1">{vehicle?.no_of_owner || '0'}</div>
                                </div>
                            </>
                        }
                    </Stack>
                    <div className="d-flex align-items-end">
                        <ButtonBase onClick={() => setDetailOpen(true)} style={{ borderRadius: 10, paddingInline: 5 }}>
                            <div className="d-flex align-items-center" style={{ color: '#B48A3C' }}>View details <Icon icon={'fluent:chevron-right-20-regular'} style={{ marginLeft: 5, height: 16 }} /></div>
                        </ButtonBase>
                    </div>
                </Box>
            </Box>
            <Box mt={4}>
                <Grid container spacing={1}>
                    <Grid item container sm={12} className="d-flex align-items-center mb-2">
                        <Grid item lg={6} md={6} sm={12} xs={12}>
                            <div className="text-semibold">Contact</div>
                        </Grid>
                        {/* <Grid item lg={6} md={6} sm={12} xs={12} sx={{ display: 'flex', justifyContent: { lg: 'end', md: 'end' } }}>
                            <CustomButton
                                title={'Add Contact'}
                                press={() => setOpenDialog(true)}
                            />
                        </Grid> */}
                    </Grid>
                    <Grid item container sm={12} xs={12} spacing={2}>
                        {/* {
                            formObj?.contacts && formObj?.contacts.length > 0 ? */}
                        <>
                            {/* {
                                        formObj?.contacts?.map((contact, index) => {
                                            const dropDownList = [
                                                { iconName: 'solar:flag-linear', label: 'Set as default', color: '#1D1B1B', permission: true, onClick: () => { setDefaultOpen(true); setSelectedRow(contact); setSelectedIndex(index) } },
                                                { iconName: 'solar:pen-linear', label: 'Edit contact', color: '#1D1B1B', permission: true, onClick: () => { setOpenDialog(true); setSelectedRow(contact); setSelectedIndex(index) } },
                                                { iconName: 'solar:user-cross-linear', label: 'Delete contact', color: '#D13536', permission: true, onClick: () => { setDeleteOpen(true); setSelectedIndex(index) } }
                                            ]
                                            const isUser = contact?.email === userEmail && ("65" + contact?.phone) === userPhone && contact?.name === username; */}
                            {/* return ( */}
                            <Grid item xs={12} key={""}>
                                {/* <div className="dashboard-card"> */}
                                {/* <div className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex aling-items-center">
                                        <div className="font-size-16 text-semibold">{formObj?.[0]?.contact?.name || '-'}</div>
                                        {isUser && <Label.CustomLabel label={'You'} backgroundColor={'#F0F0F0'} color={'#808588'} borderRadius={'8px'} border={'1px solid #F0F0F0'} marginLeft={5} />}
                                                                {
                                                                    contact?.is_default &&
                                                                    <Label.CustomLabel label={'Default'} backgroundColor={'#E7F2FC'} color={'#3674B5'} borderRadius={'8px'} border={'1px solid #E7F2FC'} marginLeft={5} />
                                                                }
                                    </div>
                                    {!contact?.is_default && <div><RenderPopOverButton items={dropDownList} /></div>}
                                </div> */}

                                <div className="d-flex align-items-center subheader-2">
                                    {/* <Icon icon={'solar:user-linear'} style={{ width: 16, marginRight: 10 }} />
                                    <div>{formObj?.salesman?.[0]?.name || '-'}</div> */}
                                    <CustomTextField
                                        title={'Contact Name'}
                                        placeholder={'Name'}
                                        values={formObj?.contacts?.[0]?.name || ''}
                                        // onChange={(e) => handleFormChange('salesman', [{ ...formObj?.salesman?.[0], name: e }])}
                                        disabled={true}
                                    />
                                </div>
                                <div className="d-flex align-items-center subheader-2 mt-2">
                                    {/* <Icon icon={'solar:phone-linear'} style={{ width: 16, marginRight: 10 }} />
                                    <div>65 {formObj?.salesman?.[0]?.phone || '-'}</div> */}
                                    <CustomTextField
                                        title={'Contact Phone Number'}
                                        placeholder={'Contact Phone Number'}
                                        type={'phone'}
                                        // InputProps={{
                                        //     startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                                        // }}
                                        values={formObj?.contacts?.[0]?.phone || ''}
                                        // onChange={(e) => handleFormChange('salesman', [{ ...formObj?.salesman?.[0], phone: e }])}
                                        disabled={true}
                                    />
                                </div>


                                {/* </div> */}
                            </Grid>
                            <Grid item lg={12} md={12} sm={12} xs={12} mt={2}>
                                <div className="text-bold mb-3">Disclaimer</div>
                                <div className="d-flex align-items-start">
                                    <Checkbox checked={formObj?.contact_agreement}
                                        checkedIcon={Helpers.checkIcon()}
                                        icon={<div style={{ width: 18, height: 18, borderRadius: 3, border: '2px solid #1D1B1B' }}></div>}
                                        sx={{
                                            '&.Mui-checked': {
                                                color: "#a0a0a0",
                                            },
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 18,
                                            },
                                        }}
                                        value={formObj?.contact_agreement}
                                        onChange={(event) => handleFormChange('contact_agreement', !formObj?.contact_agreement)} />
                                    <div style={{ marginLeft: 10, marginTop: 5 }}>
                                        <div className="subheader-2">
                                            I understand that my contact number will be publicly visible on my listing to allow potential buyers to contact me directly. I consent to this disclosure.
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                            {/* )
                                        })
                                    } */}
                        </>
                        {/* : */}
                        {/* <Grid item sm={12} className="d-flex justify-content-center align-items-center" style={{ height: 250 }}>No contacts</Grid>
                        } */}
                    </Grid>
                </Grid>
            </Box>
            <VehicleDetailsSummaryModal
                open={detailOpen}
                close={() => setDetailOpen(false)}
                selectedVehicle={vehicle}
                windowWidth={windowWidth}
                bodyList={bodyList}
                isSingPass={isSingPass}
                isDirectSeller={isDirectSeller}

            />
            <AppDialog
                title={selectedRow ? 'Edit Contact' : 'Add Contact'}
                open={openDialog}
                close={() => { setOpenDialog(false); setSelectedRow(null); setNewContact({}) }}
                positiveTitle={selectedRow ? 'Save Changes' : 'Save'}
                positivePress={() => { handleSaveChanges() }}
                cancelButton={true}
                width={'40%'}
            >
                <Grid container spacing={1}>
                    <Grid item sm={12} className="subheader-2">
                        Provide contact details of the person you would like to add.
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Name'}
                            placeholder={'Name'}
                            values={selectedRow ? selectedRow?.name : newContact?.name}
                            onChange={(e) => { selectedRow ? handleEditContactChange('name', e) : handleNewContactChange('name', e) }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Phone Number'}
                            placeholder={'Phone Number'}
                            type={'phone'}
                            InputProps={{
                                startAdornment: <div style={{ paddingLeft: 6, paddingRight: 10 }}>+65</div>,
                            }}
                            values={selectedRow ? selectedRow?.phone : newContact?.phone}
                            onChange={(e) => { selectedRow ? handleEditContactChange('phone', e) : handleNewContactChange('phone', e) }}
                        />
                    </Grid>
                    <Grid item sm={12}>
                        <CustomTextField
                            title={'Email address'}
                            placeholder={'Email address'}
                            type={'email'}
                            values={selectedRow ? selectedRow?.email : newContact?.email}
                            onChange={(e) => { selectedRow ? handleEditContactChange('email', e) : handleNewContactChange('email', e) }}
                        />
                    </Grid>

                </Grid>
            </AppDialog>
            <AppDialog
                title={'Remove Contact'}
                open={deleteOpen}
                close={() => setDeleteOpen(false)}
                positiveTitle={'Remove'}
                positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                positivePress={() => handleDeleteContact()}
                cancelButton={true}
                width={'30%'}
            >
                <div className="subheader-2">Are you sure to want to remove this contact?</div>
            </AppDialog>
            <AppDialog
                title={'Set as default'}
                open={defaultOpen}
                close={() => setDefaultOpen(false)}
                positiveTitle={'Set as Default'}
                positivePress={() => handleSetAsDefault()}
                cancelButton={true}
                width={'40%'}
            >
                Are you sure you want to set <span className="text-bold">{selectedRow?.name || '-'}</span> as the <span className="text-bold">default contact</span> for this advert?
            </AppDialog>
        </React.Fragment>
    )
}

function mapStateToProps({ General, Layout, Login }) {
    return {
        username: Login.verifyAdmin?.user?.data?.profile?.name,
        userEmail: Login.verifyAdmin?.user?.data?.profile?.email,
        userPhone: Login.verifyAdmin?.user?.data?.profile?.phone,
        windowWidth: Layout.currentWidth,
        bodyList: General.bike_types,
        isDirectSeller: Login?.verifyAdmin?.user?.data?.profile?.selected_dealer_id ? false : true,
        userData: Login?.verifyAdmin?.user?.data,

    };
}


export default connect(mapStateToProps)(AddContact);